export default __webpack_public_path__ + "static/media/no-students.daf8a715.svg";